import useCustomEffect from "../../../../../../hooks/useCustomEffect";
import ParkingLocationFormView from "./ParkingLocationFormView";

function ParkingLocationForm({
  relations,
  fetchRelation,
  selectedStep,
  selectedStepIndex,
  setFlowData,
  submitError,
  setSubmitError,
}) {
  /**
   * This effect will fetch the parking locations relation on mount.
   */
  useCustomEffect(() => {
    fetchRelation("parking_locations");
  }, []);

  /**
   * This method will handle the parking locations change event.
   * @param {array} newValues
   */
  function onParkingLocationsChange(newValues) {
    setSubmitError(null);
    setFlowData((prev) => ({
      ...prev,
      steps: prev.steps.map((step, index) => {
        if (index === selectedStepIndex) {
          return {
            ...step,
            parking_locations: newValues,
          };
        }
        return step;
      }),
    }));
  }

  return (
    <ParkingLocationFormView
      relations={relations}
      selectedStep={selectedStep}
      selectedStepIndex={selectedStepIndex}
      onParkingLocationsChange={onParkingLocationsChange}
      submitError={submitError}
    />
  );
}

export default ParkingLocationForm;
